var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDndIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0003 0.666504C6.64033 0.666504 0.666992 6.63984 0.666992 13.9998C0.666992 21.3598 6.64033 27.3332 14.0003 27.3332C21.3603 27.3332 27.3337 21.3598 27.3337 13.9998C27.3337 6.63984 21.3603 0.666504 14.0003 0.666504ZM14.0003 24.6665C8.10699 24.6665 3.33366 19.8932 3.33366 13.9998C3.33366 11.5332 4.17366 9.2665 5.58699 7.4665L20.5337 22.4132C18.6712 23.8775 16.3695 24.6713 14.0003 24.6665ZM22.4137 20.5332L7.46699 5.5865C9.32948 4.12219 11.6311 3.32836 14.0003 3.33317C19.8937 3.33317 24.667 8.1065 24.667 13.9998C24.667 16.4665 23.827 18.7332 22.4137 20.5332Z",
    fill: "#858D9D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDndIcon);
export default __webpack_public_path__ + "static/media/DNDIcon.f40b831c2c9058503269e16bcb3a9055.svg";
export { ForwardRef as ReactComponent };